<div class="footer" ><span>Copyright &copy; 2023 Abbvie. All rights reserved. All trademarks are the property of their respective owner.</span>
</div>